module.exports = __webpack_public_path__ + "img/12_sp.553ff6e3.gif";